// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MessageCategory } from "../config/message-category";
import {
  OneHotExclusionEntry,
  OneHotExclusionEntryT,
  verifyOneHotExclusionEntry,
} from "./one-hot-exclusion-entry";

/**
 * A group of exclusion entries for one message category.
 *
 * Two modes:
 * - category_wide=true: ALL values in this category are mutually exclusive
 *   (e.g., Position or Service — only one active per device). No entries needed.
 * - category_wide=false: Only the specific entries listed are exclusive.
 *   Multiple entries per group allow independent exclusion sets within
 *   the same category.
 */
export class OneHotExclusionGroup implements flatbuffers.IUnpackableObject<OneHotExclusionGroupT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OneHotExclusionGroup {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOneHotExclusionGroup(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionGroup,
  ): OneHotExclusionGroup {
    return (obj || new OneHotExclusionGroup()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsOneHotExclusionGroup(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionGroup,
  ): OneHotExclusionGroup {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OneHotExclusionGroup()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Which message category these exclusions apply to.
   */
  category(): MessageCategory {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageCategory.NONE;
  }

  /**
   * If true, the entire category is one-hot (any value evicts any other).
   * The entries field is ignored when this is true.
   */
  categoryWide(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Specific exclusion sets within the category.
   * Each entry defines one group of mutually exclusive enum values.
   */
  entries(index: number, obj?: OneHotExclusionEntry): OneHotExclusionEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new OneHotExclusionEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  entriesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * When true (default), an incoming message with active=false will NOT
   * evict a stored peer whose active=true. This preserves positive states
   * across initial-state snapshots — without it, the most recent inactive
   * report can erase the latest positive report for the same enum, leaving
   * dashboards with no usable state to render after a reconnect/refresh.
   * Set to false to restore the older behavior where any incoming peer
   * (regardless of active flag) evicts stored peers.
   */
  preservePositive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Coarse eviction-mode gate. When true (default), an incoming message
   * with active=false does NOT evict ANY peers in the group — the value
   * is silently updated in the store and no peer is touched. When false,
   * inactive incoming triggers eviction (subject to the finer
   * preserve_positive peer-level gate above). The configured default
   * matches the user expectation that, for an Up/Down exclusion group,
   * Up=false and Down=false can coexist; only an active=true incoming
   * will evict its peers.
   */
  evictOnlyWhenActive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Controls whether evictions emit explicit `active=false`
   * `FrontEndMessage` entries downstream so consumers (`QuestDB`, frontend)
   * see the transition. When false (default), peers are silently
   * removed from state stores without notifying downstream — the
   * `HashMap` value is just quietly updated.
   */
  emitDeactivations(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startOneHotExclusionGroup(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addCategory(builder: flatbuffers.Builder, category: MessageCategory) {
    builder.addFieldInt8(0, category, MessageCategory.NONE);
  }

  static addCategoryWide(builder: flatbuffers.Builder, categoryWide: boolean) {
    builder.addFieldInt8(1, +categoryWide, +false);
  }

  static addEntries(builder: flatbuffers.Builder, entriesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, entriesOffset, 0);
  }

  static createEntriesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEntriesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPreservePositive(builder: flatbuffers.Builder, preservePositive: boolean) {
    builder.addFieldInt8(3, +preservePositive, +true);
  }

  static addEvictOnlyWhenActive(builder: flatbuffers.Builder, evictOnlyWhenActive: boolean) {
    builder.addFieldInt8(4, +evictOnlyWhenActive, +true);
  }

  static addEmitDeactivations(builder: flatbuffers.Builder, emitDeactivations: boolean) {
    builder.addFieldInt8(5, +emitDeactivations, +false);
  }

  static endOneHotExclusionGroup(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createOneHotExclusionGroup(
    builder: flatbuffers.Builder,
    category: MessageCategory,
    categoryWide: boolean,
    entriesOffset: flatbuffers.Offset,
    preservePositive: boolean,
    evictOnlyWhenActive: boolean,
    emitDeactivations: boolean,
  ): flatbuffers.Offset {
    OneHotExclusionGroup.startOneHotExclusionGroup(builder);
    OneHotExclusionGroup.addCategory(builder, category);
    OneHotExclusionGroup.addCategoryWide(builder, categoryWide);
    OneHotExclusionGroup.addEntries(builder, entriesOffset);
    OneHotExclusionGroup.addPreservePositive(builder, preservePositive);
    OneHotExclusionGroup.addEvictOnlyWhenActive(builder, evictOnlyWhenActive);
    OneHotExclusionGroup.addEmitDeactivations(builder, emitDeactivations);
    return OneHotExclusionGroup.endOneHotExclusionGroup(builder);
  }

  unpack(): OneHotExclusionGroupT {
    return new OneHotExclusionGroupT(
      this.category(),
      this.categoryWide(),
      this.bb!.createObjList<OneHotExclusionEntry, OneHotExclusionEntryT>(
        this.entries.bind(this),
        this.entriesLength(),
      ),
      this.preservePositive(),
      this.evictOnlyWhenActive(),
      this.emitDeactivations(),
    );
  }

  unpackTo(_o: OneHotExclusionGroupT): void {
    _o.category = this.category();
    _o.categoryWide = this.categoryWide();
    _o.entries = this.bb!.createObjList<OneHotExclusionEntry, OneHotExclusionEntryT>(
      this.entries.bind(this),
      this.entriesLength(),
    );
    _o.preservePositive = this.preservePositive();
    _o.evictOnlyWhenActive = this.evictOnlyWhenActive();
    _o.emitDeactivations = this.emitDeactivations();
  }

  unpackFields(...fields: string[]): OneHotExclusionGroupT {
    const t = new OneHotExclusionGroupT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("category")) {
      t.category = this.category();
    }
    if (fieldSet.has("category_wide")) {
      t.categoryWide = this.categoryWide();
    }
    if (fieldSet.has("entries")) {
      t.entries = this.bb!.createObjList<OneHotExclusionEntry, OneHotExclusionEntryT>(
        this.entries.bind(this),
        this.entriesLength(),
      );
    }
    if (fieldSet.has("preserve_positive")) {
      t.preservePositive = this.preservePositive();
    }
    if (fieldSet.has("evict_only_when_active")) {
      t.evictOnlyWhenActive = this.evictOnlyWhenActive();
    }
    if (fieldSet.has("emit_deactivations")) {
      t.emitDeactivations = this.emitDeactivations();
    }
    return t;
  }
}

export class OneHotExclusionGroupT implements flatbuffers.IGeneratedObject {
  constructor(
    public category: MessageCategory = MessageCategory.NONE,
    public categoryWide: boolean = false,
    public entries: OneHotExclusionEntryT[] = [],
    public preservePositive: boolean = true,
    public evictOnlyWhenActive: boolean = true,
    public emitDeactivations: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const entries = OneHotExclusionGroup.createEntriesVector(
      builder,
      builder.createObjectOffsetList(this.entries),
    );

    return OneHotExclusionGroup.createOneHotExclusionGroup(
      builder,
      this.category,
      this.categoryWide,
      entries,
      this.preservePositive,
      this.evictOnlyWhenActive,
      this.emitDeactivations,
    );
  }

  clone(): OneHotExclusionGroupT {
    const obj = new OneHotExclusionGroupT();
    obj.category = this.category;
    obj.categoryWide = this.categoryWide;
    obj.entries = this.entries.map((e) => e.clone());
    obj.preservePositive = this.preservePositive;
    obj.evictOnlyWhenActive = this.evictOnlyWhenActive;
    obj.emitDeactivations = this.emitDeactivations;
    return obj;
  }

  equals(other: OneHotExclusionGroupT): boolean {
    if (this.category !== other.category) return false;
    if (this.categoryWide !== other.categoryWide) return false;
    if (this.entries.length !== other.entries.length) return false;
    for (let i = 0; i < this.entries.length; i++) {
      const a = this.entries[i];
      const b = other.entries[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.preservePositive !== other.preservePositive) return false;
    if (this.evictOnlyWhenActive !== other.evictOnlyWhenActive) return false;
    if (this.emitDeactivations !== other.emitDeactivations) return false;
    return true;
  }
}

export function verifyOneHotExclusionGroup(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOneHotExclusionEntry);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
